import React from "react";
import { CustomAutoComplete } from "./CustomAutoCompleteComponent";

import { AutocompleteProps } from "@mui/material/Autocomplete";
import { Controller } from "react-hook-form";
type CustomAutoCompleteControllerProps = AutocompleteProps<
  any,
  any,
  any,
  any
> & {
  name: string;
  width?: any;
  customID?: string;
  control: any;
  disableClearable?: boolean;

  fullObject?: boolean;
  onCustomChange?: (val: string) => void;
};

export const CustomAutoCompleteController = ({
  name,
  control,
  customID,
  fullObject,
  multiple,
  disableClearable,
  onCustomChange,
  ...props
}: CustomAutoCompleteControllerProps) => (
  // const {
  //   field,
  //   fieldState: { error },
  // } = useController({ name });
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value }, formState }) => (
      <CustomAutoComplete
        //@ts-ignore
        defaultValue={props.defaultValue}
        autoHighlight
        autoComplete
        disableClearable={disableClearable}
        onChange={(event, objectVal, reason) => {
          if (
            reason === "selectOption" ||
            reason === "removeOption" ||
            reason === "clear"
          ) {
            if (multiple) {
              onChange(objectVal);
              if (onCustomChange) {
                onCustomChange(objectVal);
              }
            } else {
              if (customID) {
                onChange(objectVal[customID]);
              } else {
                if (objectVal && objectVal.id) {
                  onChange(objectVal.id);
                }
              }

              if (onCustomChange) {
                if (fullObject) {
                  onCustomChange(objectVal);
                } else {
                  if (objectVal && objectVal.id) {
                    onCustomChange(objectVal.id);
                  }
                }
              }
            }
          }
        }}
        //@ts-ignore
        name={name}
        value={value}
        multiple={multiple}
        control={control}
        {...props}
      />
    )}
  />
);
